import { theme, createStyles, makeStyles } from '@forgeglobal/design-framework';

const HEADER_HEIGHT = '64px';
const MOBILE_HEADER_HEIGHT = '72px';

export const useStyles = makeStyles(() =>
  createStyles({
    appContentWrapper: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: `calc(100vh - ${HEADER_HEIGHT} - 1px)`,
      background: theme.palette.background.default,
      [theme.breakpoints.down('sm')]: {
        minHeight: `calc(100vh - ${MOBILE_HEADER_HEIGHT} - 1px)`,
      },
    },
  })
);
